// Strategic Scenarios PDF Generator - Atelier 3 Activit\u00e9 2
import jsPDF from "jspdf";
import "jspdf-autotable";

const STRINGS = {
  fr: {
    metaTitle: "Rapport Atelier 3 - Sc\u00e9narios Strat\u00e9giques",
    metaSubject: "EBIOS RM - Atelier 3 - Activit\u00e9 2 - Sc\u00e9narios Strat\u00e9giques",
    metaAuthor: "Syst\u00e8me EBIOS RM",
    metaKeywords: "EBIOS RM, Atelier 3, Sc\u00e9narios Strat\u00e9giques, Risques",
    defaultAnalysisName: "Analyse EBIOS RM",
    defaultOrg: "Organisation",
    reference: "EBIOSRM_ATELIER3_ACT2",
    locale: "fr-FR",
    status: "Finalis\u00e9",
    reportType: "Atelier 3 - Activit\u00e9 2 - Sc\u00e9narios Strat\u00e9giques",
    programLabel: "Programme :",
    programValue: "Analyse des risques \u2013 EBIOS RM",
    internal: "Interne",
    documentLabel: "Document :",
    docTypeValue: "Rapport Atelier 3 - Sc\u00e9narios Strat\u00e9giques",
    versionLabel: "Version :",
    refLabel: "R\u00e9f :",
    reportHeading: "Rapport d'Analyse de Risques:",
    fallbackScope: "Atelier 3",
    ebiosTitle: "EBIOS RM - Atelier 3",
    coverSubtitle: "Activit\u00e9 2 - Sc\u00e9narios Strat\u00e9giques",
    infoProgramLabel: "Programme",
    infoProgramValue: "Atelier 3 - Activit\u00e9 2 - Sc\u00e9narios Strat\u00e9giques",
    infoOrgLabel: "Organisation",
    notSpecified: "Non sp\u00e9cifi\u00e9",
    classificationLabel: "Classification",
    revisionFreqLabel: "Fr\u00e9quence de r\u00e9vision",
    revisionFreqValue: "Annuelle / chaque changement majeur",
    statusLabel: "Statut",
    statusValue: "Compl\u00e9t\u00e9",
    genDateLabel: "Date de g\u00e9n\u00e9ration",
    historyHeaders: ["Version", "Date", "Description, remarques", "Auteur", "V\u00e9rificateur", "Approbateur"],
    initialEntry: "Rapport initial Sc\u00e9narios Strat\u00e9giques",
    footerMethodo: "M\u00e9thodologie EBIOS RM - Atelier 3: Sc\u00e9narios Strat\u00e9giques",
    footerConfidential: "Document confidentiel - Usage interne uniquement",
    watermarkDefault: "ebiosens - rapport confidentiel",
    pageHeader: "Rapport Atelier 3 - Sc\u00e9narios Strat\u00e9giques",
    pageSectionName: "Sc\u00e9narios Strat\u00e9giques",
    pageFooterLeft: "Rapport EBIOS RM",
    pageFooterCenter: "Confidentiel - Usage interne",
    evalSectionTitle: "SC\u00c9NARIOS STRAT\u00c9GIQUES",
    noScenario: "Aucun sc\u00e9nario strat\u00e9gique trouv\u00e9.",
    decImplemented: "En place",
    decPlanned: "Pr\u00e9vu",
    decUndefined: "Non d\u00e9fini",
    noMeasures: "Aucune mesure d\u00e9finie",
    noAssets: "Aucun bien support",
    noStakeholders: "Aucune partie prenante s\u00e9lectionn\u00e9e",
    colSource: "Source de Risque",
    colObjective: "Objectif Vis\u00e9",
    colEvent: "\u00c9v\u00e9nement Redout\u00e9",
    colBV: "Valeur M\u00e9tier & Biens",
    colControls: "Mesures de Contr\u00f4le",
    colStakeholders: "Parties Prenantes",
    defaultSaveName: "rapport-scenarios-strategiques.pdf",
  },
  en: {
    metaTitle: "Workshop 3 Report - Strategic Scenarios",
    metaSubject: "EBIOS RM - Workshop 3 - Activity 2 - Strategic Scenarios",
    metaAuthor: "EBIOS RM System",
    metaKeywords: "EBIOS RM, Workshop 3, Strategic Scenarios, Risks",
    defaultAnalysisName: "EBIOS RM Analysis",
    defaultOrg: "Organization",
    reference: "EBIOSRM_WORKSHOP3_ACT2",
    locale: "en-GB",
    status: "Finalized",
    reportType: "Workshop 3 - Activity 2 - Strategic Scenarios",
    programLabel: "Program:",
    programValue: "Risk Analysis \u2013 EBIOS RM",
    internal: "Internal",
    documentLabel: "Document:",
    docTypeValue: "Workshop 3 Report - Strategic Scenarios",
    versionLabel: "Version:",
    refLabel: "Ref:",
    reportHeading: "Risk Analysis Report:",
    fallbackScope: "Workshop 3",
    ebiosTitle: "EBIOS RM - Workshop 3",
    coverSubtitle: "Activity 2 - Strategic Scenarios",
    infoProgramLabel: "Program",
    infoProgramValue: "Workshop 3 - Activity 2 - Strategic Scenarios",
    infoOrgLabel: "Organization",
    notSpecified: "Not specified",
    classificationLabel: "Classification",
    revisionFreqLabel: "Revision Frequency",
    revisionFreqValue: "Annual / Every major change",
    statusLabel: "Status",
    statusValue: "Completed",
    genDateLabel: "Generation Date",
    historyHeaders: ["Version", "Date", "Description, notes", "Author", "Reviewer", "Approver"],
    initialEntry: "Initial Strategic Scenarios Report",
    footerMethodo: "EBIOS RM Methodology - Workshop 3: Strategic Scenarios",
    footerConfidential: "Confidential Document - Internal Use Only",
    watermarkDefault: "ebiosens - confidential report",
    pageHeader: "Workshop 3 Report - Strategic Scenarios",
    pageSectionName: "Strategic Scenarios",
    pageFooterLeft: "EBIOS RM Report",
    pageFooterCenter: "Confidential - Internal Use",
    evalSectionTitle: "STRATEGIC SCENARIOS",
    noScenario: "No strategic scenarios found.",
    decImplemented: "Implemented",
    decPlanned: "Planned",
    decUndefined: "Not defined",
    noMeasures: "No measures defined",
    noAssets: "No supporting assets",
    noStakeholders: "No stakeholders selected",
    colSource: "Risk Source",
    colObjective: "Target Objective",
    colEvent: "Feared Event",
    colBV: "Business Value & Assets",
    colControls: "Control Measures",
    colStakeholders: "Stakeholders",
    defaultSaveName: "strategic-scenarios-report.pdf",
  },
};

class StrategicScenariosPdfGenerator {
  constructor(reportData, analysisData = {}, lang = "fr") {
    this.reportData = reportData || {};
    this.analysisData = analysisData || {};
    this.lang = lang;
    this.T = STRINGS[lang] || STRINGS.fr;

    // Initialize jsPDF instance in Portrait mode for the cover page
    this.pdf = new jsPDF("p", "mm", "a4");

    // Set PDF metadata
    this.pdf.setProperties({
      title: this.T.metaTitle,
      subject: this.T.metaSubject,
      author: this.T.metaAuthor,
      creator: "EBIOS RM Strategic Scenarios Report Generator",
      keywords: this.T.metaKeywords,
    });

    // Set analysis metadata for cover page
    this.metadata = {
      analysisId: this.analysisData.id || this.reportData.analysisId,
      analysisName:
        this.analysisData.name ||
        this.reportData.analysisName ||
        this.T.defaultAnalysisName,
      companyName:
        this.analysisData.companyName ||
        this.reportData.organizationName ||
        this.T.defaultOrg,
      version: "1.0",
      reference: this.T.reference,
      createdBy: "",
      lastModified: new Date().toLocaleDateString(this.T.locale),
      status: this.T.status,
      reportType: this.T.reportType,
    };
  }

  /**
   * Generate Atelier 3 Activity 2 cover page
   * Matches layout of Ecosystem Report (Atelier 3 Activity 1)
   */
  generateCoverPage() {
    const pageWidth = this.pdf.internal.pageSize.getWidth();
    const pageHeight = this.pdf.internal.pageSize.getHeight();

    // Clean white background
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.rect(0, 0, pageWidth, pageHeight, "F");

    // Header table - Programme info
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.setDrawColor(0, 0, 0);
    this.pdf.setLineWidth(0.5);
    this.pdf.rect(15, 15, 180, 10, "S");

    this.pdf.setFontSize(9);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.programLabel, 17, 21);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.T.programValue, 45, 21);

    // Internal classification label
    this.pdf.setFillColor(200, 200, 200);
    this.pdf.rect(135, 15, 60, 10, "FD");
    this.pdf.setTextColor(0, 0, 0);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.internal, 155, 21);
    this.pdf.setTextColor(0, 0, 0);

    // Document type
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.rect(15, 25, 180, 8, "S");
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.documentLabel, 17, 30);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.T.docTypeValue, 45, 30);

    // Version and Reference
    this.pdf.rect(15, 33, 90, 8, "S");
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.versionLabel, 17, 38);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.metadata.version || "1.0", 37, 38);

    this.pdf.rect(105, 33, 90, 8, "S");
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.refLabel, 107, 38);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(this.metadata.reference || this.T.reference, 120, 38);

    // Main title
    this.pdf.setFontSize(18);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.setTextColor(37, 99, 235);
    this.pdf.text(this.T.reportHeading, 105, 65, {
      align: "center",
    });

    this.pdf.setFontSize(18);
    const analysisName =
      this.reportData.analysisName || this.metadata.companyName || this.T.fallbackScope;
    const maxTW = this.pdf.internal.pageSize.getWidth() - 30;
    const al = this.pdf.splitTextToSize(analysisName, maxTW);
    al.forEach((line, i) => this.pdf.text(line, 105, 80 + i * 7, { align: 'center' }));
    const extraY = (al.length - 1) * 7;

    // EBIOS RM title
    this.pdf.setFontSize(22);
    this.pdf.setTextColor(37, 99, 235);
    this.pdf.text(this.T.ebiosTitle, 105, 105 + extraY, { align: "center" });

    this.pdf.setFontSize(16);
    this.pdf.text(this.T.coverSubtitle, 105, 115 + extraY, { align: "center" });
    this.pdf.setTextColor(0, 0, 0);

    // Information table
    const tableStartY = 135 + extraY;
    const rowHeight = 8;

    const tableData = [
      [
        this.T.infoProgramLabel,
        this.T.infoProgramValue,
      ],
      [this.T.infoOrgLabel, this.metadata.companyName || this.T.notSpecified],
      [this.T.classificationLabel, this.T.internal],
      [
        this.T.revisionFreqLabel,
        this.T.revisionFreqValue,
      ],
      [this.T.statusLabel, this.T.statusValue],
      [this.T.genDateLabel, new Date().toLocaleDateString(this.T.locale)],
    ];

    tableData.forEach((row, index) => {
      const y = tableStartY + index * rowHeight;

      // Label column (blue background)
      this.pdf.setFillColor(41, 82, 163);
      this.pdf.rect(15, y, 65, rowHeight, "FD");
      this.pdf.setTextColor(255, 255, 255);
      this.pdf.setFontSize(9);
      this.pdf.setFont("helvetica", "bold");
      this.pdf.text(row[0], 17, y + 5.5);

      // Value column (light gray background)
      this.pdf.setFillColor(235, 235, 235);
      this.pdf.rect(80, y, 115, rowHeight, "FD");
      this.pdf.setTextColor(0, 0, 0);
      this.pdf.setFont("helvetica", "normal");

      // Handle long text
      const maxWidth = 110;
      const lines = this.pdf.splitTextToSize(row[1], maxWidth);
      if (lines.length > 1) {
        const truncated =
          row[1].length > 50 ? row[1].substring(0, 47) + "..." : row[1];
        this.pdf.text(truncated, 82, y + 5.5);
      } else {
        this.pdf.text(row[1], 82, y + 5.5);
      }
    });

    // Version history table
    const historyY = 200;
    const headerHeight = 10;
    const dataRowHeight = 15;

    const headers = [
      "Version",
      "Date",
      ...this.T.historyHeaders.slice(2, 6),
    ];
    const colWidths = [18, 22, 70, 30, 20, 20];
    let xPos = 15;

    // Draw header row
    headers.forEach((header, i) => {
      this.pdf.setFillColor(41, 82, 163);
      this.pdf.setDrawColor(0, 0, 0);
      this.pdf.setLineWidth(0.5);
      this.pdf.rect(xPos, historyY, colWidths[i], headerHeight, "FD");

      this.pdf.setTextColor(255, 255, 255);
      this.pdf.setFontSize(7);
      this.pdf.setFont("helvetica", "bold");

      const maxHeaderWidth = colWidths[i] - 3;
      const headerLines = this.pdf.splitTextToSize(header, maxHeaderWidth);
      const startY =
        historyY + headerHeight / 2 - (headerLines.length - 1) * 1.5;

      headerLines.forEach((line, lineIndex) => {
        this.pdf.text(line, xPos + 1.5, startY + lineIndex * 3);
      });

      xPos += colWidths[i];
    });

    // Add data row
    xPos = 15;
    const versionData = [
      this.metadata.version || "1.0",
      new Date().toLocaleDateString(this.T.locale),
      this.T.initialEntry,
      "",
      "",
      "",
    ];

    versionData.forEach((data, i) => {
      this.pdf.setFillColor(245, 245, 245);
      this.pdf.setDrawColor(0, 0, 0);
      this.pdf.setLineWidth(0.5);
      this.pdf.rect(
        xPos,
        historyY + headerHeight,
        colWidths[i],
        dataRowHeight,
        "FD",
      );

      this.pdf.setTextColor(0, 0, 0);
      this.pdf.setFontSize(7);
      this.pdf.setFont("helvetica", "normal");

      if (data) {
        const maxColWidth = colWidths[i] - 3;
        const lines = this.pdf.splitTextToSize(data, maxColWidth);
        const maxLines = Math.floor((dataRowHeight - 2) / 3);
        const displayLines = lines.slice(0, maxLines);

        if (lines.length > maxLines && displayLines.length > 0) {
          let truncatedLine = displayLines[displayLines.length - 1];
          const ellipsisWidth = this.pdf.getTextWidth("...");
          const availableWidth = maxColWidth - ellipsisWidth;

          while (
            this.pdf.getTextWidth(truncatedLine) > availableWidth &&
            truncatedLine.length > 0
          ) {
            truncatedLine = truncatedLine.slice(0, -1);
          }
          displayLines[displayLines.length - 1] = truncatedLine + "...";
        }

        const startY =
          historyY +
          headerHeight +
          dataRowHeight / 2 -
          (displayLines.length - 1) * 1.5;
        displayLines.forEach((line, lineIndex) => {
          this.pdf.text(line, xPos + 1.5, startY + lineIndex * 3);
        });
      }
      xPos += colWidths[i];
    });

    // Footer
    const footerY = pageHeight - 20;
    this.pdf.setFontSize(8);
    this.pdf.setTextColor(107, 114, 128);
    this.pdf.setFont("helvetica", "normal");
    this.pdf.text(
      this.T.footerMethodo,
      105,
      footerY,
      { align: "center" },
    );
    this.pdf.text(
      this.T.footerConfidential,
      105,
      footerY + 8,
      { align: "center" },
    );
  }

  /**
   * Start new content page with clean background
   * @param {string} orientation - 'p' for portrait, 'l' for landscape
   */
  startNewPage(orientation = "p") {
    this.pdf.addPage("a4", orientation);
    const pageWidth = this.pdf.internal.pageSize.getWidth();
    const pageHeight = this.pdf.internal.pageSize.getHeight();

    // White background
    this.pdf.setFillColor(255, 255, 255);
    this.pdf.rect(0, 0, pageWidth, pageHeight, "F");
  }

  /**
   * Add semi-transparent diagonal watermark
   */
  addWatermark(text = null) {
    const watermarkText = text || this.T.watermarkDefault;
    this.pdf.saveGraphicsState();
    this.pdf.setGState(new this.pdf.GState({ opacity: 0.08 }));

    const pageWidth = this.pdf.internal.pageSize.getWidth();
    const pageHeight = this.pdf.internal.pageSize.getHeight();
    const centerX = pageWidth / 2;
    const centerY = pageHeight / 2;

    const watermarkInstances = [
      { x: centerX - 60, y: centerY - 60, size: 40, angle: -45 },
      { x: centerX + 60, y: centerY + 60, size: 40, angle: -45 },
    ];

    watermarkInstances.forEach((instance) => {
      this.pdf.saveGraphicsState();
      this.pdf.setFontSize(instance.size);
      this.pdf.setTextColor(140, 140, 140);
      this.pdf.setFont("helvetica", "normal");
      this.pdf.text(watermarkText, instance.x, instance.y, {
        align: "center",
        angle: instance.angle,
      });
      this.pdf.restoreGraphicsState();
    });

    this.pdf.restoreGraphicsState();
  }

  /**
   * Add professional page headers and footers to all pages
   */
  addPageNumbers() {
    const pageCount = this.pdf.internal.getNumberOfPages();

    for (let i = 1; i <= pageCount; i++) {
      this.pdf.setPage(i);
      const pageWidth = this.pdf.internal.pageSize.getWidth();
      const pageHeight = this.pdf.internal.pageSize.getHeight();

      this.addWatermark();

      if (i === 1) continue;

      // PAGE HEADER
      const headerY = 15;
      this.pdf.setDrawColor(229, 231, 235);
      this.pdf.setLineWidth(0.5);
      this.pdf.line(20, headerY + 5, pageWidth - 20, headerY + 5);

      this.pdf.setFontSize(8);
      this.pdf.setTextColor(107, 114, 128);
      this.pdf.setFont("helvetica", "normal");
      this.pdf.text(this.T.pageHeader, 20, headerY);

      this.pdf.text(this.T.pageSectionName, pageWidth - 20, headerY, { align: "right" });

      // PAGE FOOTER
      const footerY = pageHeight - 10;
      this.pdf.setDrawColor(229, 231, 235);
      this.pdf.setLineWidth(0.5);
      this.pdf.line(20, footerY - 5, pageWidth - 20, footerY - 5);

      this.pdf.setFontSize(8);
      this.pdf.setTextColor(107, 114, 128);
      this.pdf.setFont("helvetica", "normal");
      this.pdf.text(this.T.pageFooterLeft, 20, footerY);

      const centerText = this.T.pageFooterCenter;
      this.pdf.text(centerText, pageWidth / 2, footerY, { align: "center" });

      this.pdf.text(`Page ${i}`, pageWidth - 20, footerY, { align: "right" });
    }
  }

  /**
   * Process data to match the table structure
   */
  processData() {
    const {
      mappings,
      sourcesRisque,
      dreadedEvents,
      controlsData,
      stakeholders,
      businessValues,
      selectedStakeholders,
    } = this.reportData;

    if (!mappings || !sourcesRisque || !dreadedEvents) return [];

    // First pass: Combine data
    const tableData = mappings
      .map((mapping) => {
        const sourceRisk = sourcesRisque.find(
          (source) => source.id === mapping.sourceId,
        );
        const dreadedEvent = dreadedEvents.find(
          (event) => event.id === mapping.dreadedEventId,
        );

        if (!sourceRisk || !dreadedEvent) return null;

        const businessValue = businessValues.find(
          (bv) => String(bv.id) === String(dreadedEvent.businessValue),
        );

        // Get controls
        const eventControls = [];
        if (controlsData && controlsData.planData) {
          const planDataToCheck =
            controlsData.planData.plan || controlsData.planData;
          Object.values(planDataToCheck || {}).forEach((entry) => {
            // Use string comparison for IDs to be robust
            if (String(entry.dreadedEventId) === String(dreadedEvent.id)) {
              if (entry.controls && Array.isArray(entry.controls)) {
                eventControls.push(...entry.controls);
              }
            }
          });
        }

        return {
          id: mapping.id,
          sourceId: sourceRisk.id,
          dreadedEventId: dreadedEvent.id,
          sourceRisk: sourceRisk.name,
          sourceCategory: sourceRisk.category,
          objectifVise: sourceRisk.objectifVise,
          objectifViseCategory: sourceRisk.objectifViseCategory,
          dreadedEvent: dreadedEvent.name,
          dreadedEventDescription: dreadedEvent.description,
          controls: eventControls,
          businessValue: businessValue ? businessValue.name : "N/A",
          supportAssets: businessValue ? businessValue.supportAssets || [] : [],
          sourceDescription: sourceRisk.description,
        };
      })
      .filter(Boolean);

    // Sort data
    const sortedData = [...tableData].sort((a, b) => {
      const dreadedEventComparison = a.dreadedEvent.localeCompare(
        b.dreadedEvent,
      );
      if (dreadedEventComparison !== 0) return dreadedEventComparison;
      return a.sourceRisk.localeCompare(b.sourceRisk);
    });

    // Assign scenario numbers
    const scenarioNumberMapping = {};
    let scenarioCounter = 1;
    sortedData.forEach((item) => {
      const key = `${item.sourceId}-${item.dreadedEventId}`;
      if (!scenarioNumberMapping[key]) {
        scenarioNumberMapping[key] = scenarioCounter++;
      }
    });

    // Process for display (add selected stakeholders)
    return sortedData.map((item) => {
      const key = `${item.sourceId}-${item.dreadedEventId}`;
      const itemStakeholders = stakeholders
        .filter(
          (s) =>
            s.retained &&
            Array.isArray(s.concernedScenarios) &&
            s.concernedScenarios.includes(key),
        )
        .map((s) => s.name);

      return {
        ...item,
        scenarioNumber: scenarioNumberMapping[key],
        selectedStakeholders: itemStakeholders,
      };
    });
  }

  /**
   * Generate Scenarios Table
   */
  generateScenariosTable() {
    const processedData = this.processData();
    let currentY = 30;

    this.pdf.setFontSize(18);
    this.pdf.setTextColor(30, 64, 175);
    this.pdf.setFont("helvetica", "bold");
    this.pdf.text(this.T.evalSectionTitle, 20, currentY);
    currentY += 15;

    if (processedData.length === 0) {
      this.pdf.setFontSize(12);
      this.pdf.setTextColor(100, 100, 100);
      this.pdf.text(this.T.noScenario, 20, currentY);
      return;
    }

    const tableBody = processedData.map((item) => {
      // Format controls
      const controlsText =
        item.controls.length > 0
          ? item.controls
              .map(
                (c) =>
                  `- ${c.name || c.controlName} (${c.decision === "implemented" ? this.T.decImplemented : c.decision === "planned" ? this.T.decPlanned : this.T.decUndefined})`,
              )
              .join("\n")
          : this.T.noMeasures;

      // Format support assets
      const assetsText =
        item.supportAssets.length > 0
          ? item.supportAssets.map((a) => `[${a.shortId}] ${a.name}`).join("\n")
          : this.T.noAssets;

      // Format stakeholders
      const stakeholdersText =
        item.selectedStakeholders.length > 0
          ? item.selectedStakeholders.join("\n")
          : this.T.noStakeholders;

      return [
        `S${String(item.scenarioNumber).padStart(2, "0")}`,
        `${item.sourceRisk}\n(${item.sourceCategory})`,
        `${item.objectifVise}\n(${item.objectifViseCategory})`,
        item.dreadedEvent,
        `${item.businessValue}\n\n${assetsText}`,
        controlsText,
        stakeholdersText,
      ];
    });

    this.pdf.autoTable({
      startY: currentY,
      head: [
        [
          "ID",
          this.T.colSource,
          this.T.colObjective,
          this.T.colEvent,
          this.T.colBV,
          this.T.colControls,
          this.T.colStakeholders,
        ],
      ],
      body: tableBody,
      theme: "grid",
      headStyles: {
        fillColor: [30, 64, 175],
        textColor: [255, 255, 255],
        fontSize: 9,
        fontStyle: "bold",
        halign: "center",
        valign: "middle",
      },
      styles: {
        fontSize: 8,
        cellPadding: 3,
        lineColor: [200, 200, 200],
        lineWidth: 0.1,
        overflow: "linebreak",
        valign: "top",
      },
      columnStyles: {
        0: { cellWidth: 15, halign: "center", fontStyle: "bold" }, // ID
        1: { cellWidth: 35 }, // Source
        2: { cellWidth: 35 }, // Objectif
        3: { cellWidth: 40 }, // ER
        4: { cellWidth: 40 }, // VM & Biens
        5: { cellWidth: 45 }, // Controls
        6: { cellWidth: 45 }, // Stakeholders
      },
      alternateRowStyles: {
        fillColor: [245, 247, 250],
      },
      margin: { top: 30, bottom: 20, left: 10, right: 10 },
    });
  }

  /**
   * Generate complete report
   */
  async generateReport() {
    try {
      // Page 1: Cover (Portrait)
      this.generateCoverPage();

      // Page 2: Table (Landscape)
      this.startNewPage("l");
      this.generateScenariosTable();

      // Add common elements
      this.addPageNumbers();

      return this.pdf.output("blob");
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    }
  }

  save(filename = null) {
    this.pdf.save(filename || this.T.defaultSaveName);
  }
}

export default StrategicScenariosPdfGenerator;
